// Sign-up email checks: the domains accepted as real (realEmails), and the addresses allowed to
// contain a '+' (emailexceptions). Read by SignUpComponent.

export const realEmails = [
  'kinguin.net',
  'andychase.pw',
  'showbit.net',
  'acruxis.net',
  'made.net',
  'yahoo.com.tw',
  'a-one.pl',
  'cheerful.com',
  'post.cz',
  'nicoschmidt.de',
  'bhidata.com',
  'yahoo.ie',
  'myyahoo.com',
  'ld1.nl',
  'proton.me',
  'zxr.dk',
  'dacosmo.hk',
  'nicoschmidt.de',
  'nextdoorsins.com',
  'theghalays.com',
  'colobri.se',
  'yahoo.com.vn',
  'duck.com',
  'magicbean.org',
  'aol.com',
  'slingshot.co.nz',
  'outlook.is',
  'gmx.tm',
  'yahoo.ca',
  'outlook.com',
  'guru3.com',
  'gaia.eonet.ne.jp',
  'pqjp.com',
  'gmx.com',
  'mail.pt',
  'protonmail.com',
  'pm.me',
  'zoho.jp',
  'connect.com.au',
  'telefonica.net',
  'netmails.de',
  'tiscali.co.uk',
  'chello.nl',
  'pipex.com',
  'mixi.jp',
  'schweiz.org',
  'bmail.bg',
  'online.at',
  'k.vodafone.ne.jp',
  'hotmail.com',
  'runbox.no',
  'zohomail.eu',
  'poplar.ocn.ne.jp',
  'neomailbox.net',
  '163.com',
  'start.no',
  'roadrunner.com',
  'snafu.de',
  'runbox.com',
  'aapt.net.au',
  'optusnet.com.au',
  'frontiernet.net',
  'es.co.nz',
  'qq.com',
  'riseup.net',
  'libero.it',
  'onet.pl',
  'ruhr-uni-bochum.de',
  'startmail.com',
  'capcom.com',
  'orcon.net.nz',
  'bigpond.net.au',
  'yahoo.co.id',
  'lycos.com',
  'mailfence.jp',
  'stade-online.de',
  'online.ie',
  'snet.net',
  'sky.com',
  'live.com.au',
  'demail.de',
  'indigo.ie',
  'yandex.ua',
  'o2.com',
  'elisa.fi',
  'outlook.co.il',
  'eircom.net',
  'yandex.com',
  'allgaeu.org',
  'ic24.net',
  'ocn.ne.jp',
  'fujitsu.com',
  'memail.com',
  'live.fr',
  'wlpc.com',
  'outlook.fr',
  'suddenlink.net',
  'o2.pl',
  'skynet.be',
  'netspace.net.au',
  'yeah.net',
  'soverin.net',
  'outlook.cl',
  'mediacombb.net',
  'zonnet.nl',
  'alpenjodel.de',
  'sony.co.jp',
  'westnet.com.au',
  'earthlink.net',
  'xplornet.com',
  'bell.net',
  'mistral.co.uk',
  'storm.ca',
  'proximus.be',
  'osnanet.de',
  'iol.ie',
  'lycos.de',
  'wp.pl',
  'yandex.by',
  'ofir.dk',
  'wcm.ne.jp',
  'poczta.fm',
  'globalnet.co.uk',
  'telusplanet.net',
  'frisurf.no',
  'terra.es',
  'mailbox.de',
  'inbox.lv',
  'arcormail.de',
  'excite.com',
  'rr.com',
  'home.se',
  'rostock.de',
  'talktalk.net',
  'plala.or.jp',
  'mweb.co.za',
  'myway.com',
  'teleos-web.de',
  'primacom.net',
  'tesco.net',
  'sonera.fi',
  'webtv.net',
  'embarqmail.jp',
  'insightbb.jp',
  'rogers.com',
  'gmx.net',
  'yahoo.com',
  'odn.ne.jp',
  'netzero.jp',
  'online.no',
  'bluewin.ch',
  'rocketmail.com',
  'gmx.at',
  'eastlink.ca',
  'bigpond.com',
  'mindspring.com',
  'which.net',
  'clix.pt',
  'sunpoint.net',
  'hotmail.ca',
  'yahoo.no',
  'telia.com',
  'plus.net',
  'outlook.in',
  'mailfence.com',
  'internode.on.net',
  'yahoo.de',
  'cyberagent.co.jp',
  'nexgo.de',
  'fromru.com',
  'greenbee.net',
  'fastwebnet.it',
  'teksavvy.com',
  'live.nl',
  'verizon.net',
  'gungho.jp',
  'ziggo.nl',
  'mail.ru',
  'onlinehome.de',
  'icloud.com',
  'laposte.net',
  'netzero.com',
  'telus.net',
  'windstream.net',
  'nc.rr.com',
  'mts.net',
  'mail.com',
  'outlook.be',
  'dircon.co.uk',
  'yahoo.com.au',
  'mail.bg',
  'yahoo.es',
  'bol.com.br',
  'cableinet.co.uk',
  'upcmail.net',
  'kpnmail.nl',
  'o2online.de',
  'netmails.org',
  'saunalahti.fi',
  'nintendo.co.jp',
  'hetnet.nl',
  'tele2.nl',
  'dplanet.ch',
  'yahoo.dk',
  'sfr.fr',
  'live.com',
  'posteo.de',
  'countermail.jp',
  'scarlet.be',
  'onetel.com',
  'sunrise.ch',
  'swipnet.se',
  'excite.co.jp',
  'naver.jp',
  'hotmail.de',
  'fsmail.net',
  'myway.jp',
  'broadpark.no',
  'rambler.ru',
  'square-enix.com',
  'hotmail.fr',
  'pobox.sk',
  'permonline.ru',
  'orange.fr',
  'mindspring.jp',
  'online.be',
  'vodafone.ie',
  'woosh.co.nz',
  'toshiba.co.jp',
  'mailbox.hu',
  'boxbe.jp',
  'mail.yandex.com',
  'migmail.pl',
  'voo.be',
  'online.de',
  'virgin.net',
  'cableone.net',
  'unitybox.de',
  'uol.com.br',
  'online.ms',
  'virginmedia.com',
  'nm.ru',
  'homecall.co.uk',
  'netmails.com',
  'senet.com.au',
  'otto.de',
  'bbiq.jp',
  'yahoo.it',
  'sohu.com',
  'swissonline.ch',
  'open.by',
  'freeuk.com',
  'q.vodafone.ne.jp',
  'yandex.ru',
  'alumni.unc.edu',
  'btopenworld.com',
  'swbell.net',
  'netmails.info',
  'voila.fr',
  'execulink.com',
  'dodo.com.au',
  'waitrose.com',
  'actrix.co.nz',
  'yahoo.co.uk',
  'sasktel.net',
  'hush.com',
  'offensivelytolerant.com',
  'vodafone.net.nz',
  'inwind.it',
  'iprimus.com.au',
  'bk.ru',
  'net.hr',
  'livedoor.jp',
  'bellsouth.net',
  'colt.net',
  'pcpostal.com',
  'op.pl',
  'goo.ne.jp',
  'outlook.at',
  'luukku.com',
  'list.ru',
  'zen.co.uk',
  'talk21.com',
  'superonline.com',
  'clear.gen.nz',
  'spike-chunsoft.co.jp',
  'comhem.se',
  'email.de',
  'd6379.com',
  'mailbox.org',
  'phayze.com',
  'ngs.ru',
  'insightbb.com',
  'teleline.es',
  'usa.net',
  'live.ca',
  'tinyworld.co.uk',
  'hispeed.ch',
  'primus.ca',
  'rakuten.co.jp',
  'gmx.de',
  'ukdreamcast.com',
  'dr.com',
  'uk2.net',
  'iname.jp',
  'berlin.de',
  'pdx.ne.jp',
  'd.vodafone.ne.jp',
  'spark.co.nz',
  'd.jp',
  'yahoo.se',
  'netzero.net',
  'netti.fi',
  'biglobe.ne.jp',
  'fromsoftware.jp',
  'gmx.us',
  'odmail.com',
  'yahoo.co.in',
  'gazeta.pl',
  'comcast.com',
  'win.co.nz',
  'iinet.net.au',
  'au.com',
  'neomailbox.ch',
  'tutanota.com',
  'upcmail.jp',
  'vega.ocn.ne.jp',
  'yahoo.in',
  'hi-ho.ne.jp',
  'freenet.de',
  'fastmail.com',
  'protonmail.ch',
  'seznam.cz',
  'oerpub.org',
  'alpha.ocn.ne.jp',
  'zaq.ne.jp',
  'messageme.com',
  'centurytel.net',
  'uk8.net',
  'planet-interkom.de',
  'fastmail.fm',
  'neuf.fr',
  'sega.co.jp',
  'kabelbw.de',
  'tiscali.it',
  'mail.dk',
  'wave.co.nz',
  'now.mymail.net',
  'pacbell.net',
  'usa.jp',
  'tutamail.com',
  'pobox.al',
  'exemail.com.au',
  'zipworld.com.au',
  'terra.com.br',
  'clear.net.nz',
  'pironet.de',
  'sympatico.ca',
  'versanet.de',
  'livedoor.com',
  'infoseek.jp',
  'juno.jp',
  'tiscali.de',
  'n.vodafone.ne.jp',
  'jubii.dk',
  'mail.ee',
  'spray.se',
  'googlemail.com',
  'ukbuilder.com',
  'outlook.es',
  'ntlworld.com',
  'uk7.net',
  'blueyonder.co.uk',
  'aol.de',
  'alice-dsl.de',
  'boxbe.com',
  'kolumbus.fi',
  'telepac.pt',
  'live.it',
  'abv.bg',
  'tpg.com.au',
  'olymp.de',
  'interia.pl',
  'epost.de',
  'wave.ca',
  'alice.it',
  'zoho.com',
  'iname.com',
  'jcom.home.ne.jp',
  'mail.goo.ne.jp',
  'bigpond.com.au',
  'canaca.com',
  'numericable.fr',
  'netpioneer.de',
  '1und1.de',
  'home.nl',
  'olx.pl',
  's.vodafone.ne.jp',
  'actrix.gen.nz',
  'supanet.com',
  'nexicom.net',
  'tadaust.org.au',
  'mac.com',
  'acanac.net',
  'i.softbank.jp',
  'ukonline.co.uk',
  'dsl.pipex.com',
  'twc.com',
  'vip.hr',
  'line.me',
  'yahoo.com.sg',
  'aon.at',
  'opilon.com',
  'vivaldi.net',
  'c.vodafone.ne.jp',
  'yahoo.com.mx',
  'v21.me.uk',
  'tin.it',
  'outlook.ie',
  'ameblo.jp',
  'atlus.co.jp',
  'mars.ocn.ne.jp',
  'sol.dk',
  'cogeco.ca',
  'ocn.ad.jp',
  'distributel.net',
  'inter7.jp',
  'madasafish.com',
  'hitachi.co.jp',
  't-online.de',
  'adelphia.net',
  'online.fr',
  'schwarz-weiss-essen.de',
  'schoko-auge.de',
  'inbox.com',
  'charter.net',
  'vodafone.co.nz',
  'infomaniak.ch',
  'me.com',
  'yandex.kz',
  'aliceadsl.fr',
  'force9.co.uk',
  'sirius.ocn.ne.jp',
  'hotmail.es',
  'hotmail.dk',
  'nusa.ca',
  'h.vodafone.ne.jp',
  'ihug.com.au',
  'vodafone.de',
  'bbox.fr',
  'xnet.co.nz',
  'mailfence.be',
  'yahoo.com.ar',
  'golden.net',
  'online.net',
  'so-net.ne.jp',
  'ptd.net',
  'juno.com',
  'rediff.com',
  'free.fr',
  'wanadoo.fr',
  'vr-web.de',
  'clara.co.uk',
  'att.net',
  'vanilla.ocn.ne.jp',
  'koeitecmo.co.jp',
  'iskon.hr',
  '126.com',
  'bandainamco.co.jp',
  'hotmail.co.uk',
  'passagen.se',
  'paradise.net.nz',
  'emnet.ne.jp',
  'telia.se',
  'migadu.com',
  'gandi.net',
  'dr.jp',
  'sina.com',
  'pcconnect.co.nz',
  'ozemail.com.au',
  'yahoo.com.br',
  'ig.com.br',
  'ezweb.ne.jp',
  'outlook.co.nz',
  'orangehome.co.uk',
  'netcourrier.com',
  'post.com',
  'aim.com',
  'softbank.ne.jp',
  'london.com',
  'hotmail.it',
  'asahi-net.or.jp',
  'upcmail.nl',
  'optonline.com',
  'pobox.com',
  'xs4all.nl',
  'onet.eu',
  'fastwebmail.it',
  'vodafone.com.au',
  'web.de',
  'netaddress.com',
  'hushmail.com',
  'ntl.com',
  'a.vodafone.ne.jp',
  'fastmail.jp',
  'ihug.co.nz',
  'outlook.co.th',
  'netcourrier.mobi',
  'schalke04.de',
  'three.com.au',
  'pes.com',
  'telenet.be',
  'r.vodafone.ne.jp',
  'aliant.net',
  'oceanfree.net',
  'msn.com',
  'nameplanet.com',
  'yahoo.fr',
  'pacific.net.au',
  'bredband.net',
  'inbox.ru',
  'dti.ne.jp',
  'postmaster.co.uk',
  'student.uni-tuebingen.de',
  'nordnet.dk',
  'ymail.com',
  'm.vodafone.ne.jp',
  'lavabit.com',
  'o2.co.uk',
  'mailo.com',
  'mesh.ad.jp',
  'netscape.net',
  'dream.ocn.ne.jp',
  'charter.com',
  'my.com',
  'sbcglobal.net',
  'p.jp',
  'gmail.com',
  'tuta.io',
  'aleeas.com',
  'kendesign.de',
  'bellsouth.com',
  'netmails.net',
  'ukcool.com',
  'bluemail.ch',
  'bellaliant.net',
  'hvc.rr.com',
  'zetnet.co.uk',
  'posteo.net',
  'facebook.com',
  'outlook.cz',
  'surf24.de',
  'coral.ocn.ne.jp',
  'online.co.uk',
  'yahooxtra.co.nz',
  'netaddress.usa.net',
  'outlook.dk',
  'sabsd.com',
  'light66.dk',
  'gmx.ch',
  'demon.co.uk',
  'nifty.com',
  'scotlandmail.com',
  'docomo.ne.jp',
  'shaw.ca',
  'vodafone.it',
  'live.co.uk',
  'outlook.hu',
  'coxmail.com',
  'tiki.ne.jp',
  'interfree.it',
  'posteo.jp',
  'yahoo.co.jp',
  'post.jp',
  'ozu.es',
  'webcity.de',
  'pop.ru',
  'kabelmail.de',
  'totalise.co.uk',
  'zfree.co.nz',
  'myrealbox.com',
  'wanadoo.es',
  'lineone.net',
  'planet.nl',
  'btinternet.com',
  'ok.de',
  'k.jp',
  'infoclicks.co.uk',
  'rediffmail.com',
  'glhv3.de',
  'vianet.ca',
  'inspire.net.nz',
  'sapo.pt',
  'arcor.de',
  'willcom.com',
  'optonline.net',
  'ybb.ne.jp',
  'virgilio.it',
  'cablecom.ch',
  'ameritech.net',
  'zmail.ru',
  'mbox.ne.jp',
  'videotron.ca',
  'aport.ru',
  'adam.com.au',
  'netcabo.pt',
  'konami.com',
  'kimo.com',
  'phnet.fi',
  'nord-com.net',
  'post.cybercity.dk',
  'club-internet.fr',
  'countermail.com',
  'xtra.co.nz',
  'cox.net',
  'quik.co.nz',
  'attbi.com',
  'sbcglobal.com',
  'lycos.co.jp',
  'optushome.com.au',
  'tele2.it',
  'embarqmail.com',
  'knology.net',
  't-com.hr',
  'netcologne.de',
  't.vodafone.ne.jp',
  'comcast.net',
  'networld.at',
  'prodigy.net',
  'yusha.org',
  '7made.net',
  'libero.it',
  'raavig.net',
  'fantasymail.de',
  'gmx.de',
  'mail.com',
  'westernleathercraft.com.au',
  'gmx.fr',
  'feyinc.eu',
  'clarkeduncan.com',
  'unicorngroup.com',
  'unicornpayments.com',
  'unicorngrp.ch',
  'timespodcast.net',
  'wrist.pub',
  '.pub',
]

export const emailexceptions = [
  'Derek.john.ness+ai@gmail.com',
  'mdmoore313+promptchan@gmail.com',
  'redsbackdoorburner+2@gmail.com',
  'fredsbackdoorburner+2@gmail.com',
  'jan.sto@gmx.ch',
  'tagreader123+second@gmail.com',
  'houdonghan@timespodcast.net',
  'admin@wrist.pub',
  'kyle@morlove.co.uk',
  'vinnie.roe@yahoo.com',
  'luna@lunaruanne.ai',
]
